export default __webpack_public_path__ + "static/media/event-isc-west.e4f9680e.jpg";